<template>
  <div>
    <div style="margin: 4px">
      <v-card class="mb-12">
        <v-card-title>
          <span class="headline">Dados Principais</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <v-form ref="mainForm" v-model="valid" lazy-validation>
                  <v-row>
                    <!-- <v-col v-if="this.$store.state.isCnpj === false" sm="6" class="py-0"> -->
                    <v-col sm="6" class="py-0">
                      <p class="body-1">Secretaria *</p>
                      <v-autocomplete
                        color="secondary"
                        outlined
                        :items="departments"
                        item-value="sguor"
                        item-text="sguor"
                        no-data-text="Sem resultados"
                        v-model="project.secretary"
                        :rules="requiredRule"
                      ></v-autocomplete>
                    </v-col>
                    <!-- <v-col v-if="this.$store.state.isCnpj === true" sm="6" class="py-0">
                      <p class="body-1">Entidade *</p>
                      <v-autocomplete
                        color="secondary"
                        outlined
                        :items="entities"
                        item-value="ent_uor"
                        item-text="ent_uor"
                        no-data-text="Sem resultados"
                        v-model="project.secretary"
                        :rules="requiredRule"
                      ></v-autocomplete>
                    </v-col> -->
                    <v-col sm="6" class="py-0">
                      <p class="body-1">Região *</p>
                      <v-select
                        color="secondary"
                        outlined
                        :items="regions"
                        v-model="project.region"
                        :rules="requiredRule"
                      ></v-select>
                    </v-col>
                  </v-row>
                  <p class="body-1">Nome do Projeto *</p>
                  <v-text-field
                    color="secondary"
                    outlined
                    v-model="project.name"
                    counter
                    maxlength="255"
                    required
                    :rules="requiredRule"
                  ></v-text-field>
                  <div class="mb-6">
                    <p class="body-1">Objetivo *</p>
                    <v-textarea
                      color="secondary"
                      outlined
                      v-model="project.goal"
                      :rules="requiredRule"
                      required
                    ></v-textarea>
                  </div>
                  <small>* Campo de preenchimento obrigatório</small>
                </v-form>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </div>
    <v-container class="pa-0">
      <v-row justify="space-between">
        <v-col class="col-button">
          <v-btn text color="default" disabled> Anterior </v-btn>
        </v-col>
        <v-col class="col-button">
          <v-btn color="secondary" @click="next"> Próximo </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  data: () => ({
    valid: true,
    requiredRule: [v => !!v || 'Campo obrigatório'],
    project: {},
    regions: [
      'Área Continental',
      'Central Histórica',
      'Orla',
      'Intermediária',
      'Morros',
      'Noroeste',
    ],
  }),

  props: {
    departments: {
      required: false,
      type: Array,
    },
    entities: {
      required: false,
      type: Array,
    },
  },

  methods: {
    validate() {
      return this.$refs.mainForm.validate();
    },
    reset() {
      this.$refs.mainForm.reset();
    },
    resetValidation() {
      this.$refs.mainForm.resetValidation();
    },
    atribuirEmailCusto() {
      const uorFullData = this.departments.find(
        department => department.sguor === this.project.secretary,
      );
      this.project.email = uorFullData.email;
      this.project.cc_sec_user = uorFullData.cc_sec_user;
    },

    next() {
      this.atribuirEmailCusto();
      if (this.validate()) {
        this.$store.dispatch('editProject', this.project);
        this.$emit('next');
      }
    },
  },

  created() {
    this.project = this.$store.state.project;
  },
};
</script>

<style scoped>
form p {
  margin-bottom: 8px;
}
.col-button {
  flex-grow: unset;
  padding: 0 16px 16px;
}
</style>
